import Index from '../components/PrivacyTerms/Index';

let routes = {
    path: '/privacyTerms',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/privacyTerms',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/privacyTerms.js